/* eslint-disable */
import ko from 'knockout';
import Backbone from 'backbone';
import _ from 'underscore';
import $ from 'jquery';
import ViewModel from '@bingads-webui-campaign-legacy/adextension-shared/viewmodel/appLookup';
import template from '@bingads-webui-campaign-legacy/adextension-shared/template/appLookup.pug';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import 'bootstrap';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var View = Backbone.View.extend({
  initialize: function (options) {
    this.options = options || ({});
    this.ko_model = new ViewModel(this.options);
  },
  events: {
    'click .lookup': 'lookup',
    'click .appselector,.appid-select': 'appSelected'
  },
  render: function () {
    this.$el.html(template({
      i18n: i18n
    }));
    ko.applyBindings(this.ko_model, this.el);
    this.$('.applookup-input').bind('keypress', _.bind(this.lookupKeypress, this));
    return this;
  },
  toObject: function () {
    return this.ko_model.toObject();
  },
  open: function () {
    $('.applookup-input').focus();
    this.ko_model.isSearchEnabled(true);
    this.ko_model.noResultsFound(false);
  },
  lookupKeypress: function (e) {
    var keyCode = e.which || e.keyCode;
    if (keyCode !== 13) {
      return true;
    }
    this.lookup();
    e.preventDefault();
    e.stopPropagation();
  },
  lookup: function () {
    if (!this.ko_model.searchTerm()) {
      return false;
    }
    var self = this, params = {
      'where': {
        '*': {
          'contains': self.ko_model.searchTerm()
        },
        'AppPlatform': self.ko_model.appPlatform()
      }
    }, scope = {
      parent: '',
      cacheResponse: false
    };
    this.ko_model.appSearchResults.removeAll();
    return jsdata.App.findAll(params, scope).finally(withUiBlock(this.$el.parent(), undefined, true)).then(function (data) {
      self.ko_model.bindAppData(data);
      return true;
    }).catch(function (error) {
      self.ko_model.handleErrors(error);
      return false;
    });
  },
  appSelected: function (e) {
    var targetSelector = e.target.className;
    if (!this.ko_model.isSearchEnabled() && this.ko_model.appStoreId() === '') {
      return;
    }
    if (targetSelector == 'appstoreselector' || this.ko_model.appIdError()) {
      return;
    }
    this.trigger('AppSelected', this.ko_model.isSearchEnabled() ? this.getSelectedAppData(e.currentTarget) : this.ko_model.toManualObject());
    this.clearApp();
  },
  clearApp: function () {
    this.ko_model.appSearchResults.removeAll();
    this.ko_model.searchTerm('');
  },
  getSelectedAppData: function (currentTarget) {
    var appData = ko.contextFor(currentTarget).$data || ({});
    appData.ApplookupLoggingInformation = this.ko_model.applookupLoggingInformation;
    return appData;
  }
});
export default View;

